export enum Routes {
  Settings = '@trustedshops/tswp-core-plugin-settings/settings',
}
